/* eslint-disable no-shadow */
type EGender = "Male" | "Female" | "Transgender" | string;
type EMaritalStatus = "Married" | "Single" | "Widow(er)" | "Divorcee" | "";
type ENationality = "Indian" | "Non Resident Indian (NRI)" | "Person of Indian Origin (PIO)" | "";
type EEducationQualification =
  | "Graduate & Above"
  | "12th Passed"
  | "10 Passed"
  | "Below 10th"
  | "Uneducated"
  | "Diploma"
  | string;
type EOccupation =
  | "Professional"
  | "Business Owner"
  | "Housewife"
  | "Retired/Pensioner"
  | "Agriculturist"
  | "Self-employed"
  | "Salaried"
  | "Student"
  | "Others"
  | "";
type ENatureOfWork = "Administrative" | "Skilled-Manual" | "Unskilled-Manual" | "";
type ELoanCoverOption = "Level Death Benefit Option" | "Reducing Death Benefit Option" | "";
type ELoanType = "Home Loans" | "Plot Loans" | "Loan Against Property" | "";
type EPlanCoverOption = "Single Life Cover" | "Joint Life Cover" | "Proportionate Cover" | "";
type EPremiumPaymentTerm = "Single" | "";
type EPremiumFunding = "Bank/Lending Institution Funded" | "Self Funded" | "";
type EPaymentMethod = "Cheque" | "Demand Draft" | "Direct Debit" | "";
type EInterestAccruals = "Yes" | "No";

export enum PRODUCT_ID {
  GLS = 9069,
  GHS = 9078,
  GHS_FOR_JIO = 9099,
  GCS = 9086,
  GHS_IDBI = 9101,
  GCS_SREI = 9109,
  GCS_CAPRI = 9112,
  GCS_SOLFIN = 9123
}

export enum EInsurerType {
  PRIMARY = "primary",
  JOINT = "joint",
  ALL = "all"
}
// export type EExistingLifeCover = "Yes" | "No";
export interface GeneralDetails extends ProportionateDetails {
  housewifeFlag: boolean;
  title: string;
  titleCode?: string;
  otherTitle?: string;
  gender: EGender;
  genderCode?: string;
  firstName: string;
  middleName: string;
  lastName: string;
  dob: string;
  maritalStatus: EMaritalStatus;
  maritalStatusCode?: string;
  nationality: ENationality;
  nationalityCode?: string;
  countryOfResidence: string;
  countryOfResidenceCode?: string;
  cityOfResidence: string;
  dateOfLastEntry: string;
  educationQualification: EEducationQualification;
  educationQualificationCode?: string;
  mobileNo: string;
  email: string;
  occupation: EOccupation;
  occupationCode?: string;
  subOccupation?: string;
  subOccupationCode?: string;
  nameOfOrganization: string;
  designation: string;
  annualIncome: string;
  panNo: string;
  natureOfWork: ENatureOfWork;
  relationship?: string;
  isJointJourney?: boolean;
  jointFirstName?: string;
  jointMiddleName?: string;
  jointLastName?: string;
  jointDob?: string;
  jointMobileNo?: string;
  jointPan?: string;
  jointGender?: string;
  jointGenderCode?: string;
  jointAnnualIncome?: string;
  UIDNo: string;
  electronicAccount: string;
  eiaNumber: string;
  // jointRelationship?: string;
  // jointRelationshipCode?: string;
  telePhoneNo?: string;
  jointTelePhoneNo?: string;
  requirementFlag?: boolean;
  isProportionateLife?: boolean;
  primaryProportionatePercent?: string;
  primarySumAssured?: string;
  totalLoanAmountOpted?: string;
  businessOwner?: boolean;
}

export interface SecondaryDetails {
  address1: string;
  address2: string;
  address3: string;
  pinCode: string;
  city: string;
  cityCode?: string;
  state: string;
  stateCode?: string;
}
export interface AddressDetails {
  address: SecondaryDetails;
}

export interface NomineeFields {
  appointeeEmail: any;
  appointeeMobileNo: any;
  captureAppointeeBankDetails: any;
  appointeeBankName: any;
  appointeeBankAccountNumber: any;
  appointeeIfscCode: any;
  captureAppointeeAddress: any;
  appointeePermanentAddress: any;
  appointeePermanentPincode: any;
  fullName: string;
  email: string;
  captureAddress?: boolean;
  captureBankDetails?: boolean;
  bankName: string;
  bankAccountNumber: string;
  ifscCode: string;
  permanentAddress: string;
  permanentPincode: string;
  gender: EGender;
  genderCode?: string;
  relationship: string;
  relationshipCode?: string;
  dob: string;
  appointeeName: string;
  appointeeDob: string;
  appointeeRelation: string;
  appointeeRelationCode?: string;
  share: string;
  mobileNo: string;
  isMinor?: boolean;
  id?: string;
  address: string;
  isAddressSame?: boolean;
  pincode: string;
  appointeePincode: string;
  appointeeAddress: string;
  appointeeGender: EGender;
  appointeeGenderCode?: string;
  title: string;
  appointeeTitle: string;
  titleCode?: string;
  appointeeTitleCode?: string;
  isAppointeeAddressSameAsProposer?: boolean;
}

export interface NomineeDetails {
  nominee: NomineeFields[];
}

export interface ProportionateFields {
  nameOfProportionateLife?: string;
  proprtionateDob?: string;
  proprtionatePercent?: string;
  proprtionateGender?: EGender;
  genderCode?: string;
  proprtionateSumAssured?: string;
}
export interface ProportionateDetails {
  proportionate?: ProportionateFields[];
}
export interface ILoan {
  lifeCoverOption: ELoanCoverOption | string;
  lifeCoverOptionCode?: string;
  loanType: ELoanType;
  loanTypeCode?: string;
  loanAcNo: string;
  moratoriumPeriodWith: string; // not specified in design whether with or without (0 to 7 years)
  moratoriumPeriodWithCode?: string;
  moratoriumPeriodWithout: string; // list not available
  moratoriumPeriodWithoutCode?: string;
  emiAmount: string;
  emiFrequency: string;
  lifeAssuredShareOfLoan: string; // new generic field added
  loanTerm: string; // (10 to 30 years)
  loanTermCode?: string;
  loanAmount: string; // numeric but select field in design
  noOfCoBorrowers: number;
  share: string;
  loanInterestRate: string;
  dateOfDisbursement: string;
  lipAccNo: string;
  interestPeriod: EInterestAccruals;
}

export interface IPlan {
  coverOption: EPlanCoverOption;
  coverOptionCode?: string;
  deathSumInsured: string;
  coverTerm: string; // TODO: list same as loan term (1-30)
  coverTermCode?: string;
  premiumPaymentTerm: EPremiumPaymentTerm;
  premiumPaymentTermCode?: string;
}

export interface IPremiumFunding {
  premiumFunding: EPremiumFunding | string;
  premiumFundingCode?: string;
}
export interface IPremiumDetails {
  premiumMode: EPremiumPaymentTerm;
  premiumModeCode?: string;
  totalPayment: string;
  riderPremium?: number;
}

export interface IPaymentDetails {
  paymentMethod: EPaymentMethod;
  chequeNo: string;
  chequeDate: string;
  bankName: string;
  branchName: string;
  amount: string;
}

export interface IExistingLifeCover {
  policyNumber: string;
  totalSumInsured: string;
  nameOfInsuranceCompany: string;
  nameOfInsuranceCompanyCode: string;
  acceptanceTerms: string;
  acceptanceTermsCode: string;
}

export interface ExistingLifeCover {
  existingLifeCover: boolean;
  existingPolicyDetails: IExistingLifeCover[];
}

export interface LoanDetails {
  loan: ILoan;
  plan: IPlan;
  premiumDetails: IPremiumDetails;
  premiumFunding: IPremiumFunding;
  existingPolicy: ExistingLifeCover;
  riderDetails: IAddRider[];
}
export interface IAddRider {
  id?: string;
  productSelection: string;
  productSelectionCode: string;
  benefitType: string;
  benefitTypeCode: string;
  planOption?: string;
  planOptionCode?: string;
  subPlanOption?: string;
  subPlanOptionCode?: string;
  emi?: string;
  policyTerm: string;
  premiumPolicyTerm: string;
  sumAssured?: string;
  riderId?: string;
  // payment: IPaymentDetails;
}

export interface MedicalDetails {
  declare: boolean;
  medicalHealth: boolean;
  weight: string;
  height: {
    centimeter: {
      cm: string;
    };
    inchFeet: {
      inches: string;
      feet: string;
    };
  };
  measurement: string;
  familyBackground: boolean;
  diabetes: boolean;
  highBloodPressure: boolean;
  stroke: boolean;
  asthma: boolean;
  epilepsy: boolean;
  liverDisease: boolean;
  kidneyDisease: boolean;
  bloodDisorder: boolean;
  tumor: boolean;
  anxiety: boolean;
  aids: boolean;
  smoker: boolean;
  cigaratte?: boolean;
  bidi?: boolean;
  cigar?: boolean;
  panMasala?: boolean;
  gutkha?: boolean;
  chewing?: boolean;
  cigaratteAmount: string;
  bidiAmount: string;
  cigarAmount: string;
  panMasalaAmount: string;
  gutkhaAmount: string;
  chewingAmount: string;
  alcohol?: boolean;
  drugs?: boolean;
  disability?: boolean;
  gyneComplications?: boolean;
  pregnant?: boolean;
  pregnancyDuration: string;
  remarks?: string;
  beer: boolean;
  wine: boolean;
  liquor: boolean;
  lessThanOnce: boolean;
  moreThanOnce: boolean;
  once: boolean;
  daily: boolean;
  alcoholAmount: string;
  familyHealthHistory: boolean;
  familyMedicalHistory: familyMedicalData[];
  hospitalisation?: boolean;
  underTreatment?: boolean;
  majorDisorder?: boolean;
  existingApplication?: boolean;
  familyHealth?: boolean;
  smokingConsumptionSince?: number;
  alcoholConsumptionSince?: number;
  indigestion?: boolean;
  thyroid?: boolean;
  arthritis?: boolean;
  diabetesAndSugar?: boolean;
  bloodPressureHeartAttack?: boolean;
  strokeParalysis?: boolean;
  asthamaTuberculosis?: boolean;
  kidneyStoneBloodUrine?: boolean;
  anaemia?: boolean;
  cancerTumor?: boolean;
  anxietyDepression?: boolean;
  otherDisease?: boolean;
  otherDiseaseDetails?: string;
  occupationEnquiry?: boolean;
  heartDisease?: boolean;
  lungDisease?: boolean;
  highCholesterol?: boolean;
  hivAidsSTI?: boolean;
  congenitalDefect?: boolean;
  genitourinaryHearingVisionDisorder?: boolean;
  paralysis?: boolean;
  brainNervousSystemDisorder?: boolean;
  thyroidDisorder?: boolean;
  chronicDigestiveDisorder?: boolean;
  endocrineDisorder?: boolean;
  anyOtherDisease?: string;
  weightLossProgram?: boolean;
  investigateCheckups?: boolean;
  personalConsumptionSmoking?: boolean;
  personalConsumptionTobacco?: boolean;
  personalConsumptionAlcohol?: boolean;
  personalConsumptionDrugNarcotics?: boolean;
  isOccupationHazardious?: boolean;
  mines?: boolean;
  explosives?: boolean;
  radiation?: boolean;
  corrosiveChemicals?: boolean;
  hobbyQuery?: boolean;
  aviation?: boolean;
  diving?: boolean;
  mountaineering?: boolean;
  seaDiving?: boolean;
  motorRacing?: boolean;
  bungeeJumping?: boolean;
  familyHealthQuery?: boolean;
  femaleOrientedQuery?: boolean;
  femalePregnanacyQuery?: boolean;
}

export interface familyMedicalData {
  familyPersonName: string;
  familyRelation: string;
  status: string;
  sufferingAge: string;
  ageOfDeath: string;
  presentStateOfHealth: string;
  causeDeath: string;
}

export interface ProposerMedicalDetails {
  medicalDetails: MedicalDetails;
}
export interface JointMedicalDetails {
  medicalDetails: MedicalDetails;
}

export interface Products {
  GLS: number;
  GHS: number;
  GHS_FOR_JIO: number;
  GHS_IDBI: number;
  GCS: number;
  GCS_SREI: number;
  GCS_CAPRI: number;
  GCS_SOLFIN: number;
}

export interface IAssignmentClause {
  assignor: string;
  assignorJoint: string;
  assignorName: string;
  assigmentAt: string;
  signedDate: string;
  place: string;
  reasonForAssigment: string;
}

export interface IWitnessDetails {
  witnessName: string;
  address: string;
  pincode: string;
  occupation: string;
}

export interface AssignmentDetails {
  assignor: string;
  assignorJoint: string;
  assignorName: string;
  assigmentAt: string;
  signedDate: string;
  place: string;
  placeCode?: string;
  reasonForAssigment: string;
  witnessName: string;
  address: string;
  pincode: string;
  occupation: string;
  occupationCode?: string;
  witnessEmail: string;
  witnessMobile?: string;
  witnessSignature?: string;
}

export namespace MedicalQuestionnaireAPIData {
  export type ETypes =
    | "text"
    | "input"
    | "dropdown"
    | "radio"
    | "checkbox"
    | "date"
    | "textarea"
    | "switch"
    | "number";

  export interface Validation {
    max?: number;
    min?: number;
    type?: string;
    message: string;
    required: boolean;
    regexErrorMessage?: string;
    regex?: string;
  }

  export interface Condition {
    [key: string]: any;
  }

  export interface LeadingQuestions {
    key: string;
    showIf: Record<string, any>;
    label: string;
    type: string;
    placeholder: string;
    validation: Validation;
    defaultValue: string | boolean;
  }

  export interface CheckboxOptions {
    key: string;
    label: string;
    leadingQuestions: LeadingQuestions[];
    defaultValue: string | boolean;
    validation: Validation;
    showIf?: Record<string, any>;
  }

  export interface Question {
    key: string;
    type: string;
    label: string;
    options?: string[] | CheckboxOptions[];
    validation?: Validation;
    condition?: Condition;
    placeholder?: string;
    defaultValue?: string;
    logical?: "OR" | "AND";
    showIf?: Record<string, boolean>;
    helperText?: string;
  }

  export interface SubQuestions {
    multiple?: boolean;
    addMoreOption?: Record<string, any>;
    showIf?: Record<string, any>;
    questions?: Question[];
    questionIDs?: string[];
    logical?: "OR" | "AND";
  }

  export interface AddMoreOption {
    max: number;
    min: number;
  }

  export interface QuestionnaireConfig {
    [x: string]: any;
    type: ETypes;
    heading: string;
    condition?: null | Condition;
    defaultValue: boolean;
    subQuestions: SubQuestions;
    addMoreOption: AddMoreOption;
  }

  export interface QuestionnaireReducerKeys {
    sequenceID: number;
    description: MedicalQuestionnaireAPIData.QuestionnaireConfig;
    questionnaireID: string;
  }

  export interface QuestionnaireReducer {
    [key: string]: QuestionnaireReducerKeys;
  }
}
